import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";import _typeof from "@babel/runtime-corejs3/helpers/typeof";import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";import _createClass from "@babel/runtime-corejs3/helpers/createClass";import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";import _inherits from "@babel/runtime-corejs3/helpers/inherits";import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";import _get from "@babel/runtime-corejs3/helpers/get";import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = _getPrototypeOf(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = _getPrototypeOf(this).constructor;result = _Reflect$construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return _possibleConstructorReturn(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !_Reflect$construct) return false;if (_Reflect$construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}import { action, makeObservable, observable, override, toJS } from 'mobx';

import { celticsRights } from "../accessRights";
import { BasicFormController } from "./BasicFormController";
































export var DynamicFormController = /*#__PURE__*/function (_BasicFormController) {_inherits(DynamicFormController, _BasicFormController);var _super = _createSuper(DynamicFormController);








































































































  function DynamicFormController(
  fields,
  enableWhenDepsObject,
  customFields)

  {var _this;var userRoles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];_classCallCheck(this, DynamicFormController);
    _this = _super.call(this, fields, userRoles);_defineProperty(_assertThisInitialized(_this), "enableMastersObject", {});_defineProperty(_assertThisInitialized(_this), "customFields", {});
    _this.enableMastersObject = enableWhenDepsObject;
    _this.customFields = customFields || {};

    // Update fields views according to default values that passed from BE
    _Object$keys(_this.fields).forEach(function (key) {
      _this.updateServesDisabledAndShowStatuses(key, _this.fields[key].value);
    });

    makeObservable(_assertThisInitialized(_this), {
      enableMastersObject: observable,
      onFieldChange: override,
      onCheckboxChange: override,
      onContributionButtonClick: action.bound,
      populateFields: override,
      updateServesDisabledAndShowStatuses: action.bound,
      onFieldUpdate: action.bound,
      isCustomFormValid: action.bound,
      areAllFieldsValid: action.bound,
      resetCustomFieldsDataObject: action.bound,
      getCustomFormFieldsObject: action.bound,
      populateCustomFields: action.bound,
      notAvailableByUserRoles: action.bound
    });return _this;
  }_createClass(DynamicFormController, [{ key: "onFieldChange", value: function onFieldChange(e) {this.fields[e.target.name].value = e.target.value;this.updateServesDisabledAndShowStatuses(e.target.name, e.target.value);} }, { key: "onContributionButtonClick", value: function onContributionButtonClick(value, id) {this.fields[id].value = value;this.updateServesDisabledAndShowStatuses(id, value);} }, { key: "onCheckboxChange", value: function onCheckboxChange(e) {this.fields[e.target.name].value = e.currentTarget.checked;this.updateServesDisabledAndShowStatuses(e.target.name, e.currentTarget.checked);} }, { key: "onFieldUpdate", value: function onFieldUpdate(fieldKey, value) {this.fields[fieldKey].value = value;this.updateServesDisabledAndShowStatuses(fieldKey, value);} }, { key: "updateServesDisabledAndShowStatuses", value: function updateServesDisabledAndShowStatuses(masterKey, masterValue) {var _this2 = this;var servesOfThisMaster = this.enableMastersObject[masterKey];if (servesOfThisMaster) {servesOfThisMaster.forEach(function (serveObj) {var _context;if (_includesInstanceProperty(_context = serveObj.answerValues).call(_context, masterValue === null || masterValue === void 0 ? void 0 : masterValue.toString())) {var _this2$fields$serveOb, _this2$customFields$s;(_this2$fields$serveOb = _this2.fields[serveObj.key]) === null || _this2$fields$serveOb === void 0 ? void 0 : _this2$fields$serveOb.enableControl();(_this2$customFields$s = _this2.customFields[serveObj.key]) === null || _this2$customFields$s === void 0 ? void 0 : _this2$customFields$s.updateDisabledStatus(false);} else {var _this2$fields$serveOb2, _this2$customFields$s2;(_this2$fields$serveOb2 = _this2.fields[serveObj.key]) === null || _this2$fields$serveOb2 === void 0 ? void 0 : _this2$fields$serveOb2.disableControl();(_this2$customFields$s2 = _this2.customFields[serveObj.key]) === null || _this2$customFields$s2 === void 0 ? void 0 : _this2$customFields$s2.updateDisabledStatus(true);}});}} }, { key: "populateFields", value: function populateFields(dataObj) {var _this3 = this;var postAction = function postAction(fieldName) {return _this3.updateServesDisabledAndShowStatuses(fieldName, dataObj[fieldName]);};_get(_getPrototypeOf(DynamicFormController.prototype), "populateFields", this).call(this, dataObj, postAction);} }, { key: "isCustomFormValid", value: function isCustomFormValid() {var _this4 = this;var allFieldsValid = true;_Object$keys(this.customFields).forEach(function (fieldName) {if (!allFieldsValid) {return;} // eslint-disable-next-line
        if (!_this4.customFields[fieldName].isFieldValid) {allFieldsValid = false;}});return allFieldsValid;} }, { key: "areAllFieldsValid", value: function areAllFieldsValid() {return this.isFormValid() && this.isCustomFormValid();} }, { key: "resetCustomFieldsDataObject", value: function resetCustomFieldsDataObject() {var _this5 = this;_Object$keys(this.customFields).forEach(function (fieldName) {_this5.customFields[fieldName].value = _this5.customFields[fieldName].initialValue;});} }, { key: "getCustomFormFieldsObject", value: function getCustomFormFieldsObject() {var _this6 = this;var resultDataObj = {};_Object$keys(this.customFields).forEach(function (fieldName) {resultDataObj[fieldName] = toJS(_this6.customFields[fieldName].value);});return resultDataObj;} }, { key: "populateCustomFields", value: function populateCustomFields(dataObj) {var _this7 = this;_Object$keys(dataObj).forEach(function (fieldName) {if (_typeof(dataObj[fieldName]) === 'object' && dataObj[fieldName] !== null) {_this7.populateCustomFields(dataObj[fieldName]);}if (Object.prototype.hasOwnProperty.call(_this7.customFields, fieldName)) {_this7.customFields[fieldName].value = dataObj[fieldName] === undefined || dataObj[fieldName] === null ? _this7.customFields[fieldName].initialValue : dataObj[fieldName];}});} }, { key: "notAvailableByUserRoles", value: function notAvailableByUserRoles(roleAvailability) {var _this8 = this;if (celticsRights(this.userRoles)) {return false;}return roleAvailability.length > 0 && !roleAvailability.some(function (element) {var _context2;return _includesInstanceProperty(_context2 = _this8.userRoles).call(_context2, element);});} }]);return DynamicFormController;}(BasicFormController);
//# sourceMappingURL=DynamicFormController.js.map